/**
 * @group Constants

@summary
<blockquote>Default configuration values for API requests.</blockquote>

@example
```typescript
import { DEFAULT_CONFIG } from '@shared/httpService';

const apiClient = new FetchApiClient({
  baseURL: 'https://api.example.com',
  timeout: DEFAULT_CONFIG.TIMEOUT,
  retry: DEFAULT_CONFIG.RETRY
});
```
 * @internal
 */
export const DEFAULT_CONFIG = {
  /** Default request timeout in milliseconds */
  TIMEOUT: 30000,
  /** Default retry configuration */
  RETRY: {
    attempts: 3,
    delay: 1000,
    backoff: 'exponential' as const,
  },
  /** Default headers */
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  /** Default credentials policy */
  CREDENTIALS: 'same-origin' as RequestCredentials,
} as const;
